import { Typography } from "@mui/material";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { DATE_TIME_FORMATS, TIME_FORMATS } from "@/config";
import useErrorLogger from "@/utils/useErrorLogger";

const AppointmentDateTimeSummary = ({
  startTime,
  endTime,
  medspaTimezone,
  primaryVariant = "subtitleDefault",
  secondaryColor = "gray.main",
}: {
  startTime: string | Date;
  endTime: string | Date;
  medspaTimezone: string;
  primaryVariant?: "labelSmall" | "subtitleDefault";
  secondaryColor?: "text.secondary" | "gray.main";
}) => {
  const logError = useErrorLogger();

  const formatSafely = (date: string | Date, formatString: string) => {
    try {
      return format(
        utcToZonedTime(new Date(date), medspaTimezone),
        formatString
      );
    } catch (error) {
      logError(error, "Invalid date format", { date, formatString });

      return "Invalid date";
    }
  };

  return (
    <>
      <Typography
        variant={primaryVariant}
        sx={{
          mb: primaryVariant === "subtitleDefault" ? 0.5 : 0,
        }}
      >
        {formatSafely(startTime, DATE_TIME_FORMATS.BOOKING)}
      </Typography>
      <Typography
        variant="paragraphSmall"
        sx={{
          color: secondaryColor,
        }}
      >
        {`${formatSafely(startTime, TIME_FORMATS.BOOKING)} - ${formatSafely(endTime, TIME_FORMATS.BOOKING)} (${medspaTimezone.replace("_", " ")})`}
      </Typography>
    </>
  );
};

export default AppointmentDateTimeSummary;
